import React from 'react';
import ProfitAndLossSummary from 'components/containers/ProfitAndLossv2';

const ProfitAndLoss = () => (
  <ProfitAndLossSummary />
);

export default ProfitAndLoss;
